/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `LME` - LME
* `LME_MWP` - LME & MWP
 */
export type PriceIndexEnum = typeof PriceIndexEnum[keyof typeof PriceIndexEnum];


export const PriceIndexEnum = {
  LME: 'LME',
  LME_MWP: 'LME_MWP',
} as const;
